<template>
  <aside v-on="$listeners" :class="buttonListClass">
    <div v-for="(buttonOption, index) in buttonOptions" :key="`button-${index}`">
      <template v-if="showButton(buttonOption.url)">
        <import-template-button
          v-if="showImportTemplateButton(buttonOption)"
          v-bind="buttonOption"
        ></import-template-button>
        <common-anchor-button
          v-else-if="showAnchorButton"
          v-bind="buttonOption"
          :confirm="confirm(buttonOption)"
          :list-collapsed-button="listCollapsedButton"
          :current-view-name="currentViewName"
          :is-detail-view-visible="isDetailViewVisible"
          :is-in-expanded="isInExpanded"
          :button-style="buttonStyle"
          :button-list-type="buttonListType"
          :layout-direction="layoutDirection"
        ></common-anchor-button>
        <common-button
          v-else-if="typeof buttonOption.action === 'function'"
          v-bind="buttonOption"
          @click="buttonOption.action"
          :button-list-type="buttonListType"
        ></common-button>
        <common-button
          v-else
          @click="runAction(buttonOption)"
          :button-type="buttonOption.buttonType"
          :button-style="buttonOption.buttonStyle"
          :icon="buttonOption.icon"
          :loading="buttonOption.loading"
          :name="buttonOption.name"
          :button-list-type="buttonListType"
        ></common-button>
      </template>
    </div>
  </aside>
</template>

<script>
/**
 * @param ButtonList component
 *
 * @description A listák gombjainak megjelenítésére szolgáló component
 */
import CommonButton from './CommonButton'
import CommonAnchorButton from './CommonAnchorButton'
import ImportTemplateButton from './ImportTemplateButton.vue'

export default {
  name: 'ButtonList',
  components: {
    ImportTemplateButton,
    CommonButton,
    CommonAnchorButton,
  },
  props: {
    buttonStyle: {
      type: String,
    },
    buttonOptions: {
      type: Array,
      required: true,
    },
    buttonListType: {
      type: String,
    },
    actionsInlineVisible: {
      type: Boolean,
      default: false,
    },
    isDetailViewVisible: {
      type: Boolean,
      default: false,
    },
    isInModal: {
      type: Boolean,
      default: false,
    },
    isInExpanded: {
      type: Boolean,
      default: false,
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    currentViewName: {
      type: String,
      default: '',
    },
    listCollapsedButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      containerOpt: '',
    }
  },
  methods: {
    confirm(buttonOption) {
      return buttonOption.confirm && buttonOption.confirm.active ? this.$i18n.t(buttonOption.confirm.message) : null
    },
    runAction(buttonOption) {
      this.$emit('change', buttonOption)
    },
    showAnchorButton(option) {
      return option.url && option.buttonType !== 'button'
    },
    showImportTemplateButton(option) {
      return option.buttonType === 'importTemplateButton'
    },
    showButton(url) {
      return !this.isCollapsed || !url.includes('update')
    },
  },
  computed: {
    layoutDirection() {
      return this.buttonListType === 'footer' ||
        this.listCollapsedButton ||
        (this.currentViewName === 'gridView' && (this.actionsInlineVisible || !this.isDetailViewVisible)) ||
        this.currentViewName === 'detailView'
        ? 'horizontal-button-layout'
        : 'vertical-button-layout'
    },
    needWideMargin() {
      return this.currentViewName === 'gridView' ? this.isDetailViewVisible : this.isInExpanded
    },
    buttonListClass() {
      let listClass = this.layoutDirection
      if (this.needWideMargin) listClass += ' my-3'
      if (this.listCollapsedButton) listClass += ' mt-2'
      return listClass
    },
  },
  created() {
    if (this.buttonOptions) {
      this.buttonOptions.forEach(({ containerClass }) => {
        if (containerClass) this.containerOpt += ` ${containerClass}`
      })
    }
  },
}
</script>

<style scoped>
.horizontal-buttons {
  padding-left: 0 !important;
  padding-right: 2px !important;
}
.vertical-button-layout {
  margin-top: 5px;
  margin-bottom: 5px;
}
.horizontal-button-layout {
  margin: 0 0 5px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media screen and (max-width: 768px) {
  .horizontal-button-layout {
    padding-top: 40px;
  }
}
</style>
